import { useContext, useEffect, useState } from "react";
import {
  StyleSheet,
  Image,
  useWindowDimensions,
  ImageBackground,
} from "react-native";

import { useToast } from "react-native-toast-notifications";
import { View } from "../../components/shared/Themed";
import { ForgotPasswordScreen } from "./ForgotPasswordScreen";
import { LoginScreen } from "./LoginScreen";
import DeviceOrientationContext from "../../components/context/DeviceOrientationContext";
import { Card } from "react-native-paper";
import { LoginWithTandaScreen } from "./LoginWithTandaScreen";

function MainScreen({}) {
  const toast = useToast();
  const dimensions = useWindowDimensions();

  const { isSmallDevice } = useContext(DeviceOrientationContext);
  const [displayForgetPasswordScreen, setDisplayForgetPasswordScreen] =
    useState<boolean>(false);
  const [displayLoginWithTendaScreen, setDisplayLoginWithTendaScreen] =
    useState<boolean>(false);
  const [forgetPasswordStatus, setForgetPasswordStatus] =
    useState<boolean>(false);

  useEffect(() => {
    if (forgetPasswordStatus) {
      toast.show("A password reset link has sent to your email", {
        type: "success",
      });
    }
  }, [forgetPasswordStatus]);

  return (
    <ImageBackground
      source={require("../../assets/gradientBlue.jpg")}
      style={styles.bgImage}
      resizeMode="cover"
    >
      {/* Dark overlay to slightly darken background */}
      <View
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0,0,0,0.15)",
        }}
      />
      {/* Login Form - glassmorphism card */}
      <View
        testID="loginRightPanel"
        style={{
          width: isSmallDevice ? "90%" : "40%",
          maxWidth: 550,
          minWidth: isSmallDevice ? undefined : 450,
          backgroundColor: "rgba(255, 255, 255, 0.70)",
          borderRadius: 20,
          paddingVertical: 40,
          paddingHorizontal: isSmallDevice ? "8%" : "5%",
          alignSelf: "center",
          borderWidth: 1,
          borderColor: "rgba(255,255,255,0.5)",
          // @ts-ignore – web-only backdrop blur
          backdropFilter: "blur(16px)",
          WebkitBackdropFilter: "blur(16px)",
          shadowColor: "rgba(0,0,0,0.1)",
          shadowOffset: { width: 0, height: 8 },
          shadowOpacity: 1,
          shadowRadius: 32,
        }}
      >
        <Image
          style={[styles.tinyLogo, { width: isSmallDevice ? 250 : 320 }]}
          source={require("../../assets/logo2.svg")}
          resizeMode="contain"
        />
        <View
          style={{
            width: "100%",
            alignSelf: "center",
            maxWidth: 450,
            backgroundColor: "transparent",
          }}
        >
          {displayForgetPasswordScreen ? (
            <ForgotPasswordScreen
              setForgetPasswordStatus={setForgetPasswordStatus}
              setDisplayForgetPasswordScreen={setDisplayForgetPasswordScreen}
            />
          ) : displayLoginWithTendaScreen ? (
            <LoginWithTandaScreen
              setDisplayForgetPasswordScreen={setDisplayForgetPasswordScreen}
              setDisplayLoginWithTendaScreen={setDisplayLoginWithTendaScreen}
            />
          ) : (
            <LoginScreen
              setDisplayForgetPasswordScreen={setDisplayForgetPasswordScreen}
              setDisplayLoginWithTendaScreen={setDisplayLoginWithTendaScreen}
            />
          )}
        </View>
      </View>
    </ImageBackground>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: "row",
  },
  tinyLogo: {
    width: 250,
    height: 80,
    alignSelf: "center",
    marginBottom: "6%",
  },
  content: {
    padding: 0,
    borderColor: "#eee",
    borderWidth: 1,
    borderStyle: "solid",
  },
  contentLabel: {
    justifyContent: "center",
    alignContent: "center",
    flexDirection: "row",
    paddingTop: "5%",
    paddingBottom: "5%",
  },
  bgImage: {
    flex: 1,
    width: "100%",
    height: "100%",
    justifyContent: "center",
  },
  errorColor: {
    color: "red",
  },
  successColor: {
    color: "#037d50",
  },
  px_5: { paddingLeft: "5%", paddingRight: "5%" },
  forgetPasswordLink: {
    marginTop: "2%",
    fontStyle: "italic",
    color: "#adacac",
    textDecorationLine: "underline",
  },
  boldFont: {
    fontWeight: "bold",
  },
});

export default MainScreen;
